enum LevelNodePreventCacheReasons {
    StarChestAnimations = 'StarChestAnimations',
    RewardStars = 'RewardStars',
    CurrentNode = 'CurrentNode',
}
export default LevelNodePreventCacheReasons;
